import React from "react";

import classes from "./Sidebar.module.css";

import {
	faEnvelope,
	faPhoneAlt,
	faFilePdf,
} from "@fortawesome/free-solid-svg-icons";
import { faLinkedinIn, faGithub } from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import mine from "../../assets/imgs/mine.jpg";

const Sidebar = (props) => {
	return (
		<div className={classes.Sidebar}>
			<div>
				<div className={classes.Border}>
					<img src={mine} className={classes.Img} alt='Sheikh Muzammil Ahmed' />
				</div>
				<div className={classes.Name}>
					<h3>
						Sheikh Muzammil <span style={{ color: "white" }}>Ahmed</span>
					</h3>
					<p>MERN Stack Developer</p>
					<p>Seeking for a New Opportunity</p>
				</div>
				<div className={classes.SocialLinks}>
					<FontAwesomeIcon className={classes.fa5Icon} icon={faPhoneAlt} />
					<a href='tel:+923002985106'>+92-300-2985106</a>
				</div>
				<div className={classes.SocialLinks}>
					<FontAwesomeIcon className={classes.fa5Icon} icon={faEnvelope} />
					<a href='mailto:sma3797@gmail.com'>sma3797@gmail.com</a>
				</div>
				<div className={classes.SocialLinks}>
					<FontAwesomeIcon className={classes.fa5Icon} icon={faLinkedinIn} />
					<a
						target='_blank'
						rel='noopener noreferrer'
						href='https://www.linkedin.com/in/sheikhmuzammil/'>
						/in/sheikhmuzammil/
					</a>
				</div>
				<div className={classes.SocialLinks}>
					<FontAwesomeIcon className={classes.fa5Icon} icon={faGithub} />
					<a
						target='_blank'
						rel='noopener noreferrer'
						href='https://github.com/sma3797'>
						/sma3797/
					</a>
				</div>
				<div style={{ display: "block" }} className={classes.SocialLinks}>
					<FontAwesomeIcon
						className={classes.fa5Icon}
						icon={faFilePdf}
						size='lg'
					/>
					&nbsp;
					<a
						target='_blank'
						href='https://drive.google.com/open?id=12pSAqDXgjGkr_Xm5BhIOlUM4OGgmEGO1'
						rel='noopener noreferrer'>
						Download My Resume
					</a>
				</div>
			</div>
			<div className={classes.Footer}>
				<span>
					&copy; 2021 - Made with React with <span>&hearts;</span>
				</span>
			</div>
		</div>
	);
};

export default Sidebar;
